module.exports = __webpack_public_path__ + "img/National Trust Bank Web Logo.c578a0e3.png";